import List from 'containers/ConfigGenerals/List';
import Edit from 'containers/ConfigGenerals/Edit';
import Create from 'containers/ConfigGenerals/Create';
import Show from 'containers/ConfigGenerals/Show';

export default { List, Edit, Create, Show };
